import { Directive } from '@angular/core';

/**
 * Marks host-projected caption content for {@link CadsFieldComponent} (and form-kit controls that embed it). Use instead
 * of {@link CadsFieldConfig.helperText} when the caption needs interactive markup (e.g. a link-style button). Plain
 * helper copy can stay on `helperText`; projected caption takes precedence when both are supplied.
 */
@Directive({
  selector: '[cadsFieldCaption]',
  standalone: true,
  host: {
    class: 'cads-field-caption-slot',
  },
})
export class CadsFieldCaptionSlotDirective {}
